import { IntegrationKey } from 'entities/Integrations'
import { MergeField } from 'entities/MergeField/model/MergeField'
import { mockMergeField } from 'entities/MergeField/mock/MergeFieldMock'

export const buildGoogleCalendarMergeFields = (integrationId: number) => [
  new MergeField({
    ...mockMergeField,
    integrationId,
    integrationKey: IntegrationKey.google_calendar,
    label: 'Meeting information',
    name: 'meeting_information',
    type: 'text',
    template: '{ google_calendar.meeting_information }',
  }),
]
